// hooks/useAircraftFilters.ts
import { useState, useEffect } from "react";
import { MapEngine } from "@/client/map/core/MapEngine";
import type {
  AircraftFilterEngine,
  RowId,
  ColumnId,
} from "@/client/map/managers/aircraft/AircraftFilterEngine";

export function useAircraftFilters() {
  const [snapshot, setSnapshot] = useState<any>(null);

  useEffect(() => {
    let interval: any;
    let unsubscribe: (() => void) | null = null;

    const attachEngine = () => {
      const manager = MapEngine.getInstance()?.getAircraftManager();
      if (manager?.filterEngine) {
        clearInterval(interval);

        // Initial set
        setSnapshot(manager.filterEngine.getSnapshot());

        // Listen for internal model shifts
        unsubscribe = manager.filterEngine.subscribe(() => {
          setSnapshot(manager.filterEngine.getSnapshot());
        });
      }
    };

    interval = setInterval(attachEngine, 100);
    attachEngine();

    return () => {
      clearInterval(interval);
      if (unsubscribe) unsubscribe();
    };
  }, []);

  const getEngine = () =>
    MapEngine.getInstance()?.getAircraftManager()?.filterEngine;

  return {
    snapshot,
    toggleAll: () => {
      getEngine()?.toggleAll();
    },
    toggleRow: (rowId: RowId) => {
      getEngine()?.toggleRow(rowId);
    },
    toggleCol: (colId: ColumnId) => {
      getEngine()?.toggleCol(colId);
    },
    toggleCell: (rowId: RowId, colId: ColumnId) => {
      getEngine()?.toggleCell(rowId, colId);
    },
  };
}
